import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setLogs: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.total = payload.total;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.loading = !!payload.loading;
};
